export default __webpack_public_path__ + "static/media/0250.8938b992.jpg";